//statisticarifiti
import { environment } from "../../../environments/environment";
import { AnaColumn } from "../forms-template.service";


export const precison = environment.PRECISION
export const StatisticaRifiutiDett: AnaColumn[] = [
  {
    itemType: "group", colCount: "12", caption: "Quantità iniziali alla data indicata",
    data: [
      { type: 'campo', colVisible: false, hideOnEdit: true, disableOnUpdate: true, dataField: "id" },
      /*{
        type:'button',colSpan:"2",
        button:{
          hint:'Dettagli',
          name:'dettagli',
          text:'Dettagli',
          icon:'link'
        }
      },*/
      {
        disableOnUpdate: true,
        type: 'campo',
        dataField: "idTipoCarico",
        caption: "Tipo Carico",
        editorType: "dxSelectBox",
        colSpan: "6",
        dataType: "",
        //width: 6.5 + 'vw',
        colVisible: true,
        lista: {
          dataSource: 'TipoCarico',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        }
      },
      /*
      {type: 'campo', maxLength: '15', dataField: "cer", dataType: "", caption: "CER",},
      {type: 'campo', maxLength: '35', dataField: "descrizioneCer", dataType: "", caption: "Decrizione",},
      {type: 'campo', maxLength: '35', dataField: "riferimentoCER", dataType: "", caption: "Riferimento",},
      {type: 'campo', maxLength: '1', dataField: "isPericoloso", dataType: "boolean", caption: "Pericoloso",},
      {
        disableOnUpdate:true,       
        type: 'campo', width: '250px', dataField: "idStatoFisico", dataType: "", caption: "Stato Fisico",
        lookup: {
          wingap: true,
          caption: 'Stato Fisico',
          dataSource: 'StatoFisico',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice'
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione'
            }
          ]
        }
      },
      */
      {
        type: 'number', colVisible: true,
        /*tipoTotale:'sum',
        dxoSummary:{  
          summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },*/
        editorType: "dxNumberBox", dataField: "giacenzaIniziale", dataType: "",
        caption: "Giacenza Iniziale Kg"
      },
      {
        type: 'number', colVisible: true,
        /*tipoTotale:'sum',
        dxoSummary:{  
          summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },*/
        editorType: "dxNumberBox", dataField: "carico", dataType: "",
        caption: "Carico",
      },
      {
        type: 'number', colVisible: true,
        /*tipoTotale:'sum',
        dxoSummary:{  
          summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },*/
        editorType: "dxNumberBox", dataField: "scaricoInterno", dataType: "",
        caption: "Scarico"
      },
      {
        type: 'number', colVisible: true,
        /*tipoTotale:'sum',
        dxoSummary:{  
          summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },*/
        editorType: "dxNumberBox", dataField: "scaricoATerzi", dataType: "",
        caption: "Scarico a Terzi"
      },
      {
        type: 'number', colVisible: true,
        /*tipoTotale:'sum',
        dxoSummary:{  
          summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },*/
        editorType: "dxNumberBox", dataField: "giacenzaFinale", dataType: "",
        caption: "Giacenza Finale"
      },
      //----------------- ok -----------------------------------------
      /*
      {
        
        type: 'number', colVisible: true, colSpan: "4",
        tipoTotale:'sum',
        dxoSummary:{  
          summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },
        editorType: "dxNumberBox", dataField: "pesoKg", dataType: "",
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        caption: "Quantita Kg", format: '000000.###'
      },
      {
        type: 'campo',colVisible:true, caption:'Cod. Cer', disabled:true,dataField:"idcer",colSpan:"3", 
        editorType: "",groupIndex:1                   
      },
      {
        disableOnUpdate:true,
        
        type: 'campo', colSpan: "9", caption: "Des. Cer", dataField: "cer", dataType: "",
        //width:30*aspect,
        //colWidth:"450px",
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        lookup: {
          wingap: true,
          dataSource: 'cer', valueExpr: 'id', displayExpr: 'descrizione',
          showClearButton: true,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice'
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione'
            }
          ]
        }
      },
      {
        type: 'empty', colSpan: "4"
      },
      {
        
        type: 'number', colVisible: true, colSpan: "4",
        tipoTotale:'sum',
        dxoSummary:{  summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },
        editorType: "dxNumberBox", dataField: "volumeMC", dataType: "",
        caption: "Volume", format: '000000.###',maxLength:"10"
      },          
      {        
        type: 'campo', maxLength: '10', colSpan: "4", dataField: "protocollo", dataType: "", caption: "N.Protocollo",
        helpText:'Il campo deve terminare con /YYYY es. Prot. 256/2020'
      },
      */
    ]
  },
]


export const caricoGiacenzeDetail: AnaColumn[] = [
  //.....................................................

  {
    itemType: "group", colCount: "12", caption: "d",
    data: [
      { type: 'campo', colVisible: false, hideOnEdit: true, disableOnUpdate: true, dataField: "id" },
      { type: 'campo', colVisible: false, maxLength: '15', dataField: "eer", dataType: "", caption: "EER", },
      { type: 'campo', colVisible: false, maxLength: '1', dataField: "isPericoloso", dataType: "boolean", caption: "Pericoloso", },
      { type: 'campo', colVisible: false, maxLength: '35', dataField: "riferimentoEER", dataType: "", caption: "Riferimento", },
      { type: 'campo', colVisible: false, maxLength: '35', dataField: "descrizioneStatoFisico", dataType: "", caption: "Stato Fisico" },
      { type: 'campo', colVisible: false, hideOnEdit: true, dataField: "idGiacenzaIniziale" },
      {
        type: 'campo', colVisible: true, maxLength: '35', dataField: "descrizioneTipoCarico", dataType: "",
        caption: "Tipo Carico", colWidth: '330px'
      },

      {
        type: 'number', colVisible: true,
        editorType: "dxNumberBox", dataField: "giacenzaIniziale", dataType: "",
        caption: "Giacenza Iniziale",
        format: precison,
        colAlignment: 'right',
        colWidth: '200px',

      },

      {
        type: 'number', editorType: "dxNumberBox", dataField: "carico", dataType: "",
        caption: "Quantità Carico",
        format: precison,
        colAlignment: 'right',
        colWidth: '200px',

      },
      {
        type: 'number', editorType: "dxNumberBox", dataField: "scaricoInterno", dataType: "",
        caption: "Scarico Interno", colAlignment: 'right', colWidth: '200px', format: environment.PRECISION,
      },
      {
        type: 'number', editorType: "dxNumberBox", dataField: "scaricoATerzi", dataType: "",
        caption: "Scarico a Terzi",
        format: precison,
        colAlignment: 'right',
        colWidth: '200px',

      },
      {
        type: 'number', editorType: "dxNumberBox", dataField: "giacenzaFinale", dataType: "",
        caption: "Giacenza Finale",
        format: precison,
        colAlignment: 'right',
        colWidth: '200px',

      },
    ]
  },
  //......................................................
]

export const StatisticaRifiuti: AnaColumn[] = [
  {
    itemType: "group", colCount: "12", caption: "Quantità iniziali alla data indicata",
    data: [
      { type: 'campo', colVisible: false, hideOnEdit: true, disableOnUpdate: true, dataField: "id" },
      {
        type: 'button', colSpan: "2",
        button: {
          hint: 'Giacenza alla data di installazione ',
          name: 'GiacenzaIniziale',
          text: 'GiacenzaIniziale',
          icon: 'edit'
        }
      },
      {
        type: 'button', colSpan: "2",
        button: {
          hint: 'Dettagli',
          name: 'dettagli',
          text: 'Dettagli',
          icon: 'link'
        }
      },

      /*{
       disableOnUpdate:true,
       type: 'campo',
       dataField: "idTipoCarico",
       caption: "Tipo Carico",
       editorType: "dxSelectBox",
       colSpan: "6",
       dataType: "",
       //width: 6.5 + 'vw',
       colVisible: true,      
       lista: {             
         dataSource: 'TipoCarico',
         valueExpr: 'id',
         displayExpr: 'descrizione',
         static: true
       }
     },*/
      { type: 'campo', maxLength: '15', dataField: "eer", dataType: "", caption: "EER", },
      /* {type: 'campo', dataField: "isPericoloso", 
        editorType:'dxCheckBox',showEdito lways:false,dataType: "boolean",
         caption: "Pericoloso",trueText:'P',falseText:'N',
         colWidth:30
       },*/
      /*{type: 'campo', maxLength: '35', dataField: "descrizioneTipoCarico", dataType: "", caption: "Tipo Carico",},*/

      /*{type: 'campo', maxLength: '35',dataField: "descrizioneStatoFisico", dataType: "", caption: "Stato Fisico",colVisible:false},*/



      {
        colVisible: true,
        type: 'campo', width: '250px', groupIndex: 0, dataField: "idStatoFisico", dataType: "", caption: "Stato Fisico",
        lookup: {
          wingap: true,
          caption: 'Stato Fisico',
          dataSource: 'StatoFisico',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice'
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione'
            }
          ]
        }
      },
      { type: 'campo', maxLength: '35', dataField: "riferimentoEER", dataType: "", caption: "Riferimento", },
      {
        type: 'campoSpecial', colVisible: true,
        editorType: 'dxSelectBox',
        dataField: "idRegistro",
        caption: 'Registro',
        width: 12 + 'vw',
        placeHolder: '',
        lookup: {
          dataSource: "RegistroRifiuti",
          valueExpr: 'id', displayExpr: 'descrizione',
          // filter: '?$filter=(idSede eq $idDestinatario)',
          queryString: '?$filter=(idSede eq $idDestinatario)',
          wingap: true,
          showClearButton: false,
        }
      },
      {
        type: 'number', colVisible: true, colAlignment: 'right',
        tipoTotale: 'sum',
        dxoSummary: {
          summaryType: 'sum',
          showInGroupFooter: true,
          alignByColumn: true,
          valueFormat: precison,
          displayFormat: "Totale: {0}",
          alignment: 'right'
        },
        editorType: "dxNumberBox", dataField: "giacenzaIniziale", dataType: "",
        format: precison,
        caption: "Giac. Iniziale Kg",
      },
      {
        type: 'number', colVisible: true, colAlignment: 'right',
        format: precison,
        tipoTotale: 'sum',
        dxoSummary: {
          summaryType: 'sum',
          showInGroupFooter: false,
          alignByColumn: true,
          displayFormat: "Totale: {0}",
          valueFormat: precison,
          alignment: 'right'
        },
        editorType: "dxNumberBox", dataField: "carico", dataType: "",
        caption: "Carico",
      },
      {
        type: 'number', colVisible: true, colAlignment: 'right',
        tipoTotale: 'sum',
        format: precison,
        dxoSummary: {
          summaryType: 'sum',
          showInGroupFooter: false,
          alignByColumn: true,
          displayFormat: "Totale: {0}",
          valueFormat: precison,
          alignment: 'right'
        },

        editorType: "dxNumberBox", dataField: "scaricoInterno", dataType: "",
        caption: "Scarico Interno",
      },
      {
        type: 'number', colVisible: true, colAlignment: 'right',
        format: '#0.000',
        tipoTotale: 'sum',
        dxoSummary: {
          summaryType: 'sum',
          showInGroupFooter: false,
          alignByColumn: true,
          displayFormat: "Totale: {0}",
          valueFormat: precison,
          alignment: 'right'
        },
        editorType: "dxNumberBox", dataField: "scaricoATerzi", dataType: "",
        caption: "Scarico a Terzi",
      },
      {
        type: 'number', colVisible: true, colAlignment: 'right',
        tipoTotale: 'sum',
        format: precison,
        dxoSummary: {
          summaryType: 'sum',
          showInGroupFooter: false,
          alignByColumn: true,
          displayFormat: "Totale: {0}",
          valueFormat: precison,
          alignment: 'right'
        },
        editorType: "dxNumberBox", dataField: "giacenzaFinale", dataType: "",
        caption: "Giacenza Finale"
      },
      {
        caption: 'x', type: 'campo', colWidth: '5', dataField: 'scroll'
      }
      //----------------- ok -----------------------------------------
      /*
      {
        
        type: 'number', colVisible: true, colSpan: "4",
        tipoTotale:'sum',
        dxoSummary:{  
          summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },
        editorType: "dxNumberBox", dataField: "pesoKg", dataType: "",
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        caption: "Quantita Kg", format: '000000.###'
      },
      {
        type: 'campo',colVisible:true, caption:'Cod. Cer', disabled:true,dataField:"idcer",colSpan:"3", 
        editorType: "",groupIndex:1                   
      },
      {
        disableOnUpdate:true,
        
        type: 'campo', colSpan: "9", caption: "Des. Cer", dataField: "cer", dataType: "",
        //width:30*aspect,
        //colWidth:"450px",
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        lookup: {
          wingap: true,
          dataSource: 'cer', valueExpr: 'id', displayExpr: 'descrizione',
          showClearButton: true,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice'
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione'
            }
          ]
        }
      },
      {
        type: 'empty', colSpan: "4"
      },
      {
        
        type: 'number', colVisible: true, colSpan: "4",
        tipoTotale:'sum',
        dxoSummary:{  summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },
        editorType: "dxNumberBox", dataField: "volumeMC", dataType: "",
        caption: "Volume", format: '000000.###',maxLength:"10"
      },          
      {        
        type: 'campo', maxLength: '10', colSpan: "4", dataField: "protocollo", dataType: "", caption: "N.Protocollo",
        helpText:'Il campo deve terminare con /YYYY es. Prot. 256/2020'
      },
      */
    ]
  },
]  